import classNames from 'classnames';
import Link from 'components/Link';
import LoadingIndicator from 'components/LoadingIndicator';
import ProductFeedList from 'components/ProductFeedList';
import styles from './ProductFeed.module.scss';

export default function ProductFeed({
  backInStockText,
  badgeImages,
  closeoutText,
  ctaHref,
  ctaHrefText,
  ctaOnClick,
  defaultCategoryImages,
  featuredProductText,
  feedId,
  groupedDiscountsContent,
  header,
  headerStyle = 'fw-900 text-primary fs-15 fs-xl-26',
  isLoading = false,
  loadingMessage = 'Loading Product Info',
  newProductText,
  noProductsMessage = 'No products available',
  packagedDateTooltipInfo,
  placeholder,
  packagedDateConfiguration,
  priceDropText,
  products = [],
  showDetailedFeedCard = false,
  subheader,
  subheaderStyle = 'fw-900 text-primary fs-7 fs-xl-9 mb-4',
  terpeneTooltipInfo,
}) {
  const handleOnClick = () => {
    if (ctaOnClick && typeof ctaOnClick === 'function') {
      ctaOnClick(feedId);
    }
  };
  return (
    <>
      <div className="d-flex flex-row justify-content-between mx-8 pb-8 pb-xl-14">
        <div className="me-8 font-roboto">
          {header && <h2 className={headerStyle}>{header}</h2>}
          {subheader && <p className={subheaderStyle}>{subheader}</p>}
        </div>
        {(ctaHref || ctaOnClick) && (
          <Link
            href={ctaHref}
            className={classNames(
              'btn bg-white border-2 border-primary d-inline-block font-sofia fs-7 fw-700 px-10 py-5 my-auto text-primary text-uppercase',
              styles.view_all
            )}
            onClick={handleOnClick}
          >
            {ctaHrefText}
          </Link>
        )}
      </div>
      {!isLoading && products.length > 0 && (
        <ProductFeedList
          backInStockText={backInStockText}
          badgeImages={badgeImages}
          closeoutText={closeoutText}
          defaultCategoryImages={defaultCategoryImages}
          featuredProductText={featuredProductText}
          groupedDiscountsContent={groupedDiscountsContent}
          idPrefix={feedId}
          newProductText={newProductText}
          packagedDateTooltipInfo={packagedDateTooltipInfo}
          placeholder={placeholder}
          packagedDateConfiguration={packagedDateConfiguration}
          priceDropText={priceDropText}
          products={products}
          showDetailedFeedCard={showDetailedFeedCard}
          terpeneTooltipInfo={terpeneTooltipInfo}
        />
      )}
      {!isLoading && products.length === 0 && (
        <div className="w-100 mx-auto p-8 font-sofia fs-12 text-primary text-center">
          {noProductsMessage}
        </div>
      )}
      {isLoading && <LoadingIndicator loadingMessage={loadingMessage} />}
    </>
  );
}
